<template>
	<article class="info" v-if="info">
		<div class="pt-4" v-if="info.id === 1" />
		<section class="info-top d-flex flex-wrap"> <!-- @TODO: info-top -->
			<div class="px-5 pb-3" style="flex-basis: 80%; flex-grow: 1;">
				<h1 class="mb-5">{{ info.name }}</h1>
				<hr>
			</div>
		</section>
		<section class="px-5" style="overflow: auto">
			<ktMailForm v-if="info && info.id === 7" />
			<html-description
				:class="{'d-flex': info && info.id === 30}"
				ref="description"
				:html="info.content"
				@html-loaded="onHtmlLoad"
			/>
			<manufacturer-list v-if="info && info.id === 34" />
			<stores-map v-if="info && info.id === 5" />
			<jobsPage v-if="info && info.id === 21" />
			<giftCardForm v-if="info && info.id === 28" />
			<giftCardCheck v-if="info && info.id === 30" />

		</section>
		<section class="px-3 mt-4" style="overflow: auto">
			<div v-if="info.children">
				<div v-for="child in filteredChildren" class="col-md-6 mb-3" :key="'info-page-link-' + child.id">
					<router-link class="tile info-page-links" :to="formatLink(child.id, child.name)">
						<div class="p-4 pull-left mr-5 stretch-y">
							<ximg
								lazy
								:src="'/api/dynimg/info/' + child.icon + '/1A1A1D'"
								:ariaLabel="child.name + ' ikon'"
								role="img"
							/>
						</div>
						<div class="ap p-4" style="word-wrap: nowrap; text-overflow: ellipsis; white-space: nowrap; overflow: hidden">
							<div class="name">
								{{ child.name }}
							</div>
							<div class="one-liner">
								{{ child.oneLiner }}
							</div>
						</div>
					</router-link>
				</div>
			</div>

			<hr>

			<div class="info-footer pt-5" v-if="info.id > 1">
				<p class="small">Hittar du inte det du söker? Gå till
					<router-link :to="formatLink(1, 'Kundservice')">Kundservice</router-link>
					eller <router-link :to="formatLink(7, 'Kontakta oss')">Kontakta oss</router-link>.
				</p>
			</div>
		</section>
		<modal v-model="modalOpen" name="becomeMember">
			<member-form
				class="add-to-wislisht-member-form"
				:showCloseButton="false"
				value="register"
			/>
		</modal>
	</article>
</template>

<script>
import waja from 'waja';
import bus from 'eventbus';
import router from 'router';
import { setCustomNav } from 'datastore/navStatus';
import { error, urlFormat, standardRoute } from 'utils';
import { mapGetters } from 'vuex';
import Hls from 'hls.js';

/*
** Lazy Loading
*/
const jobsPage = () => import('./jobs');
const giftCardForm = () => import('./gift-card-form');
const giftCardCheck = () => import('./gift-card-check');
const ktMailForm = () => import('./kt-mail-form');
const manufacturerList = () => import('./manufacturer-list.vue');

export default {
	data () {
		return {
			info: {},
			modalOpen: false,
			memberButton: null,
			totalDuration: 0,
		};
	},
	components: {
		jobsPage,
		giftCardForm,
		giftCardCheck,
		ktMailForm,
		manufacturerList,
	},
	handleNavigation () {
		return true;
	},
	beforeRouteEnter (to, frm, next) {
		waja.get('info/' + to.params.id)
			.useCdn(true)
			.on('success', res => {
				next(vm => {
					vm.info = res.data.info;
				});
			})
			.on('error', res => {
				if (res.status === 404) {
					next(error(404));
				} else if (res.status === 500) {
					next(error(500, 'Det går för tillfället inte att komma åt denna sida. Försök gärna senare.'));
				}
			})
			.go();
	},
	beforeRouteUpdate (to, frm, next) {
		if (~~to.params.id === ~~frm.params.id) {
			next();
			return;
		}
		waja.get('info/' + to.params.id)
			.useCdn(true)
			.on('success', res => {
				next(vm => {
					vm.info = res.data.info;
				});
			})
			.on('error', () => {
				next(error(404));
			})
			.go();
	},
	methods: {
		reload () {
			waja.get('info/' + this.$route.params.id)
				.useCdn(true)
				.on('success', res => {
					this.info = res.data.info;
				})
				.go();
		},
		updateParamsAndNav () {
			router.updateParams({
				id: this.info.id,
				name: urlFormat(this.info.name),
			});

			if (this.info.breadcrumbs && this.info.id > 1) {
				setCustomNav({
					customPath: this.info.breadcrumbs.concat({
						title: this.info.name,
						route: null,
					}),
				});
			} else {
				setCustomNav({
					customPath: [],
				});
			}
		},
		onHtmlLoad () {
			if (this.$route.query.scrollId) {
				this.$refs.description.scrollToId(this.$route.query.scrollId);
			}
			this.memberButton = document.getElementById("becomeMember");
			if (this.memberButton?.addEventListener) {
				this.memberButton.addEventListener("click", this.handleMemberButtonClick, false);
			}

			let memberVideo = document.getElementById('memberVideo');
			if (memberVideo) {
				waja.get('user/me/video')
				.on('success', res => {
					if (res.data?.videoSrc) {
						memberVideo.setAttribute('poster', res.data.videoThumbnail);
						memberVideo.classList.remove('hide');
						const hls = new Hls();
						const stream = res.data.videoSrc ;
						const video = memberVideo;
						hls.loadSource(stream);
						hls.attachMedia(video);

						hls.once(Hls.Events.LEVEL_LOADED, function (event, data) {
							this.totalDuration = data.details.totalduration;
						});

						hls.on(Hls.Events.FRAG_CHANGED, function (event, data) {
							if (data.frag.endPTS >= this.totalDuration) {
								waja.post('achievement/attention-span').go();
							}
						});
					}
				}).go();
			}
		},
		findChild (id) {
			if (! this.info.children) {
				return null;
			}
			return this.info.children.find(child => child.id === id);
		},
		handleMemberButtonClick () {
			if (this.userId) {
				this.$router.push({
					name: 'member.benefits',
					params: {
						id: this.userId,
					},
				});
			} else {
				this.modalOpen = ! this.modalOpen;
			}
		},
		formatLink (id, name) {
			return this.$router.route(standardRoute('info', { id, name }));
		},
 	},
	computed: {
		filteredChildren () {
			if (! this.info.children) {
				return [];
			}
			return this.info.children;
		},
		...mapGetters ({
			userId: 'user/currentUserId',
		}),
	},
	watch: {
		info (to) {
			this.updateParamsAndNav();
		},
	},
	mounted () {
		bus.$on('localization:locale-updated', this.reload);
	},
	beforeDestroy () {
		bus.$off('localization:locale-updated', this.reload);
		if (this.memberButton) {
			this.memberButton.removeEventListener("click", this.handleMemberButtonClick, false);
		}
	},
	layoutOptions: {
		leftCol: true,
	},
};
</script>
